import { useCallback } from 'react';
import { useRouter } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useUserSettings } from '@features/user/hooks/useUserSettings';
import { UserAuthMenu } from '@features/user/ui/UserAuthMenu/UserAuthMenu';

export function UserAuthMenuWidget({ alwaysRound }: { alwaysRound?: boolean }) {
  const { user, login, logout } = useAuth();
  const router = useRouter();
  const settings = useUserSettings();

  const handleLogin = useCallback(() => login(), [login]);

  const editProfileLink = user?.globalId
    ? `https://id.chessopen.ru/profile/${user.globalId}?source=PlayChessOpen&back=${router.latestLocation.href}`
    : undefined;

  return (
    <UserAuthMenu
      user={user}
      editProfileLink={editProfileLink}
      settings={user ? settings : undefined}
      alwaysRound={alwaysRound}
      onLogin={handleLogin}
      onLogout={logout}
    />
  );
}
